import {Http, isUndefined, lerp} from "./helpers";
import {WorkerScope} from "./models";

export const parseLogsBuilder = (worker: WorkerScope) => {
    const parseLogs =  async () => {
        if(!isUndefined(worker.initObject)) {
            let delayTime = 1;
            if (worker.logs.length) {
                clearTimeout(worker.timeout);
                const log = worker.logs.shift()!;
                try {
                    await Http.post(worker.initObject.clickStreamURL, JSON.stringify(log));
                } catch(err) {
                    if (err.status == 429 || (err.status >= 500 && err.status < 510)) {
                        worker.logLogger.warn('3rd party call failed', worker.initObject, log, err);
                        delayTime = Math.floor(lerp(100, 1000, Math.random()));
                        if (log.retryCount < 3) {
                            log.retryCount++;
                            worker.logs.push(log);
                        } else {
                            worker.logLogger.error('3rd party call failed after 3 retries, removing from queue', worker.initObject, log, err);
                        }
                    } else {
                        worker.logLogger.error('3rd party call failed - unhandled status code', worker.initObject, log, err);
                    }
                }
            } else {
                delayTime = 50;
            }
            worker.timeout = setTimeout(parseLogs, delayTime);
        } else {
            // Log missing clickStreamURL
            if (!worker.ranOnce) {
                worker.logLogger.warn('No click stream URL, please send init event that contains an init object');
                worker.ranOnce = true;
            }
            clearTimeout(worker.timeout);
            setTimeout(parseLogs, 100);
        }
    }
    return parseLogs;
}
